import generateTypes from '../../utils/generateTypes';

export const GET_ORGANIZATIONS = generateTypes('GET_ORGANIZATIONS');
export const RESET_ORGANIZATIONS = generateTypes('RESET_ORGANIZATIONS');
